import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@ag-common-lib/public-api';

@Pipe({ name: 'primaryShippingAddress' })
export class PrimaryShippingAddressPipe implements PipeTransform {
  transform(addresses: Address[]): Address {
    return Array.isArray(addresses) ? addresses.find((address: Address) => address?.is_primary_shipping) : null;
  }
}
